import { render, staticRenderFns } from "./SideBarPreloader.vue?vue&type=template&id=2dae8684&scoped=true&lang=pug&"
import script from "./SideBarPreloader.vue?vue&type=script&lang=ts&"
export * from "./SideBarPreloader.vue?vue&type=script&lang=ts&"
import style0 from "./SideBarPreloader.vue?vue&type=style&index=0&id=2dae8684&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dae8684",
  null
  
)

export default component.exports